var PageSearch = (function ($) {

    PageSearch = function (options) {
        var that = this;
        
        that.class = {
            price: 'js-price',
            variant: 'js-variant',
            result_empty: 'result-empty'
        };

        that.selectors = {
            search_form: '.js-search-form',
            input_date_back: '.js-date-back'
        }

        // DOM
        that.$wrapper = options['$wrapper'];
        that.$search_variants_wrapper = that.$wrapper.find('.js-search-variants-wrapper');
        that.$search_skeletons = that.$wrapper.find('.js-search-skeletons');

        that.$search_form = that.$wrapper.find(that.selectors.search_form);
        that.$input_date_back = that.$search_form.find(that.selectors.input_date_back);

        // CONST        
        that.search_params_hash = options['search_params_hash'];
        
        // selected_variants -- these are the options we got from the meta search engines (aviasales, yandex.travel).
        // The user in the SERP of the meta-search engine has already selected the desired flight and brand.
        that.selected_variants_options = options['v'];
        that.selected_variants_hash = that.selected_variants_options['value'];
        that.selected_variants_modal = that.selected_variants_options['modal'];

        // DYNAMIC VARS

        // INIT
        that.init();
    };

    PageSearch.prototype.init = function () {
        var that = this;

        //
        that.workupVariants();
        //
        that.saleIgnoreHandler();
    };

    PageSearch.prototype.workupVariants = function () {
        var that = this;
        
        if (!that.search_params_hash) {
            return false;
        }

        var href = $.sa.build_url('search/variants'),
            data = {search_params_hash: that.search_params_hash};

        if (arguments[0] !== undefined) {
            data.sale_ignore = arguments[0];
        }

        that.$search_variants_wrapper.hide();
        that.$search_skeletons.show();

        $.sa.loading_bar.animate(10000, 80, false);

        $.post(href, data, function (html) {
            that.$search_skeletons.hide();
            that.$search_variants_wrapper.html(html).show();
        })
        .done(function () {
            that.autoSelectVariants();
        })
        .always(function () {
            $.sa.loading_bar.done();
        });
    };

    PageSearch.prototype.saleIgnoreHandler = function () {
        var that = this;

        that.$search_variants_wrapper.on('change', '.js-sale-active-checkbox', function () {
            var $checkbox = $(this),
                sale_ignore = !$checkbox.is(':checked');
            
             that.workupVariants(sale_ignore);
        })
    };

    PageSearch.prototype.autoSelectVariants = function () {
        var that = this;
        
        if (!that.selected_variants_hash || !that.selected_variants_hash.length) {
            return false;
        }
        
        if (that.$search_variants_wrapper.find('.' + that.class.result_empty).length) {
            return false;
        }
        
        var variants_hash = that.selected_variants_hash.split('!');
        $.each(variants_hash, function (i, variant_hash) {
            var $variant_price = that.$search_variants_wrapper.find(`.${that.class.price}[data-hash="${variant_hash}"]`),
                $variant = $variant_price.parents('.js-variant');
            
            if ($variant_price.length && $variant.length) {
                $variant.data('search_variant').select(variant_hash);
            } else {
                that.__showModalNoVariants();
                return false;
            }
        });
    };

    PageSearch.prototype.__showModalNoVariants = function () {
        var that = this;

        $.uiModal({
            header_icons: that.selected_variants_modal.icons,
            content: that.selected_variants_modal.content,
            custom_class: 'page-search-error-modal'
        });
    };
    
    return PageSearch;

})($);